import { Stack } from 'expo-router'
import Head from 'expo-router/head'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Linking, Pressable, ScrollView, View } from 'react-native'
import Footer from '@/components/Footer'
import PublicHeader from '@/components/PublicHeader'
import { Text } from '@/components/ui/Text'
import { useThemeColors } from '@/contexts/ThemeContext'

export default function Privacy() {
  const { t } = useTranslation()
  const colors = useThemeColors()
  const [scrollOffset, setScrollOffset] = useState(0)

  const sections = [
    { title: `1. ${t('privacy.section1Title')}`, body: t('privacy.section1Body') },
    { title: `2. ${t('privacy.section2Title')}`, body: t('privacy.section2Body') },
    { title: `3. ${t('privacy.section3Title')}`, body: t('privacy.section3Body') },
    { title: `4. ${t('privacy.section4Title')}`, body: t('privacy.section4Body') },
    { title: `5. ${t('privacy.section5Title')}`, body: t('privacy.section5Body') },
    { title: `6. ${t('privacy.section6Title')}`, body: t('privacy.section6Body') },
    { title: `7. ${t('privacy.section7Title')}`, body: t('privacy.section7Body') },
    { title: `8. ${t('privacy.section8Title')}`, body: t('privacy.section8Body') },
    { title: `9. ${t('privacy.section9Title')}`, body: t('privacy.section9Body') },
    { title: `10. ${t('privacy.section10Title')}`, body: t('privacy.section10Body') },
  ]

  return (
    <View className="flex-1" style={{ backgroundColor: colors.background }}>
      <Head>
        <title>{t('privacy.pageTitle')}</title>
        <meta name="description" content={t('privacy.pageDescription')} />
        <link rel="canonical" href="https://turbinago.com/privacy" />
        <meta property="og:title" content={t('privacy.pageTitle')} />
        <meta property="og:description" content={t('privacy.pageDescription')} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://turbinago.com/privacy" />
        <meta property="og:image" content="https://turbinago.com/og-default.png" />
        <meta property="og:site_name" content="Turbina" />
        <meta property="og:locale" content="es_419" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t('privacy.pageTitle')} />
        <meta name="twitter:description" content={t('privacy.pageDescription')} />
        <meta name="twitter:image" content="https://turbinago.com/og-default.png" />
      </Head>
      <Stack.Screen options={{ headerShown: false }} />
      <PublicHeader scrollOffset={scrollOffset} activeRoute="/privacy" />

      <ScrollView
        className="flex-1"
        onScroll={(e) => setScrollOffset(e.nativeEvent.contentOffset.y)}
        scrollEventThrottle={16}
        contentContainerStyle={{
          flexGrow: 1,
        }}
      >
        <View className="flex-1 pt-6 pb-10 max-w-[1200px] self-center w-full">
          <View className="px-6">
            <View className="w-full">
              {/* Heading */}
              <View className="items-center gap-2 mb-8">
                <h1
                  className="text-xl font-medium native:font-medium text-center leading-tight"
                  style={{ color: colors.dark }}
                >
                  {t('privacy.heading')}
                </h1>
              </View>

              {/* Sections */}
              <View className="gap-6">
                {sections.map((section) => (
                  <View
                    key={section.title}
                    className="rounded-2xl p-6 gap-2"
                    style={{ backgroundColor: colors.surface }}
                  >
                    <Text
                      className="text-lg font-medium native:font-medium"
                      style={{ color: colors.dark }}
                    >
                      {section.title}
                    </Text>
                    <Text className="text-sm leading-relaxed" style={{ color: colors.muted }}>
                      {section.body}
                    </Text>
                  </View>
                ))}
              </View>

              <View
                className="rounded-2xl p-6 mt-8 items-center gap-2"
                style={{ backgroundColor: colors.surface }}
              >
                <Text
                  className="text-sm text-center leading-relaxed"
                  style={{ color: colors.muted }}
                >
                  {t('privacy.contactPrompt')}
                </Text>
                <Pressable onPress={() => Linking.openURL(`mailto:${t('privacy.contactEmail')}`)}>
                  <Text className="text-sm font-medium underline" style={{ color: colors.primary }}>
                    {t('privacy.contactEmail')}
                  </Text>
                </Pressable>
              </View>
            </View>
          </View>
        </View>
        <Footer showTermsLink />
      </ScrollView>
    </View>
  )
}
